import $ from 'jquery';

$(function () {

  const notificationButton = $('.btn-notification');
  const notificationsMenu = $('.notifications-menu');

  $(document).on('click', function(e) {
    if (!notificationButton.is(e.target) && notificationsMenu.hasClass('notifications-menu--active')) {
      notificationsMenu.removeClass('notifications-menu--active');
    }
  });

  notificationButton.on("click", function (e) {
    e.stopPropagation();

    $(this).removeClass("btn-notification--active");

    notificationsMenu.toggleClass('notifications-menu--active');

    var notificationIDs = [];
    $(".notifications-menu__item").each(function () {
      var notificationID = $(this).data("notification");
      notificationIDs.push(notificationID);
    });

    // Store the notification IDs in a cookie
    setCookie("notification_ids", JSON.stringify(notificationIDs));
  });

  const notificationCount = $(".notifications-menu__item").length;
  const storedNotificationIDs = JSON.parse(getCookie("notification_ids"));
  const storedNotificationCount = storedNotificationIDs ? storedNotificationIDs.length : 0;

  if (notificationCount !== storedNotificationCount || !storedNotificationIDs) {
    $(notificationButton).addClass("btn-notification--active");
  } else {
    $(notificationButton).removeClass("btn-notification--active");
  }

  // Function to set a cookie
  function setCookie(name, value, days) {
    const expires = "";
    if (days) {
      var date = new Date();
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
      expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + value + expires + "; path=/";
  }

  // Function to get a cookie
  function getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) === ' ') c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  }

});